import * as React from "react";

import { cn } from "@/lib/utils";

type ItemStatus = "late" | "needs-you" | "waiting" | "upcoming" | "draft";

const STATUS_LABEL: Record<ItemStatus, string> = {
  late: "Late",
  "needs-you": "Needs You",
  waiting: "Waiting on Client",
  upcoming: "Upcoming",
  draft: "Draft"
};

const STATUS_COLOR: Record<ItemStatus, string> = {
  late: "text-danger",
  "needs-you": "text-warn",
  waiting: "text-info",
  upcoming: "text-fg-4",
  draft: "text-fg-4"
};

type StatusIconProps = Omit<React.SVGProps<SVGSVGElement>, "ref"> & {
  status: ItemStatus;
};

/** Linear's 14px status circles for Home's Vertical rows. */
function StatusIcon({ status, className, ...props }: StatusIconProps) {
  return (
    <svg
      data-slot="status-icon"
      viewBox="0 0 14 14"
      fill="none"
      role="img"
      aria-label={STATUS_LABEL[status]}
      className={cn("size-3.5 shrink-0", STATUS_COLOR[status], className)}
      {...props}
    >
      <circle
        cx="7"
        cy="7"
        r="5.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeDasharray={status === "draft" ? "2 1.6" : undefined}
      />
      {status === "late" ? (
        <circle cx="7" cy="7" r="2" fill="currentColor" />
      ) : null}
      {status === "needs-you" ? (
        <path d="M7 3.5a3.5 3.5 0 0 1 0 7z" fill="currentColor" />
      ) : null}
      {status === "waiting" ? (
        <path
          d="M7 4.25V7l1.75 1.25"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
    </svg>
  );
}

export { StatusIcon, STATUS_LABEL };
export type { ItemStatus, StatusIconProps };
